export default __webpack_public_path__ + "static/media/logo-white.c62bfe4d.svg";